import { render } from "./UpdateJobStatusButtonAndModal.vue?vue&type=template&id=03c24dec"
import script from "./UpdateJobStatusButtonAndModal.vue?vue&type=script&lang=js"
export * from "./UpdateJobStatusButtonAndModal.vue?vue&type=script&lang=js"

import "./UpdateJobStatusButtonAndModal.vue?vue&type=style&index=0&id=03c24dec&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__